import { useRef } from 'react'
import PropTypes from 'prop-types'
import gql from 'graphql-tag'
import { Query } from '@apollo/client/react/components'
import LinearProgress from '@material-ui/core/LinearProgress'
import NoSsr from '@material-ui/core/NoSsr'
import defaults from '@config/defaults'
import Error from '@components/error'
import ErrorBoundary from '@components/error/boundary'
import MatchPlayHeader from '@components/match-play-header'
import MatchPlayContentSection from '@components/match-play-content-section'
import MatchPlayLeaderboard from './match-play-leaderboard'

const QUERY = gql`
query MatchPlayLeaderboard ($id: String!, $feedId: String!) {
  tournament(tournamentId: $id, feedId: $feedId) {
    name
    currentRound
    currentRoundState
    updatedAt
    matchPlaySummary {
      teamName
      teamPosition
      teamPointsTotal
      isWinner
    }
    matchPlayLeaderboard {
      playerId
      player {
        firstName
        lastName
        headshot
      }
      round
      roundName
      matchId
      teamName
      currentMatchScore
      currentRoundState
      matchWinner
      matchLeader
      finalMatchScore
      teeTime
      thru
    }
  }
}
`

export default function MatchPlayLeaderboardWithData(props) {
  const pollInterval = process.browser ? defaults.matchPlayLeaderboardPollInterval : null
  const fetchPolicy = process.browser ? 'cache-and-network' : 'cache-first'

  const {
    fullLeaderboard,
    findCoachTitle,
    findCoachSubtitle,
    findCoachCta,
    articles,
    isEmbedView,
  } = props

  const leaderboardRef = useRef(null)

  return (
    <NoSsr>
      <Query
        query={QUERY}
        variables={props}
        pollInterval={pollInterval}
        fetchPolicy={fetchPolicy}
        context={{ clientName: 'pga-datafeed' }}
      >
        {({
          error, data, loading,
        }) => {
          const response = data && data.tournament
          if (loading && !response) return <LinearProgress />
          if (error) return <Error error={error} />

          return response ? (
            <ErrorBoundary>
              <MatchPlayHeader
                {...props}
                {...response}
                scores={response.matchPlaySummary || []}
                leaderboardRef={leaderboardRef}
              />
              {fullLeaderboard
              && (
                <>
                  <MatchPlayContentSection
                    findCoachTitle={findCoachTitle}
                    findCoachSubtitle={findCoachSubtitle}
                    findCoachCta={findCoachCta}
                    articles={articles?.articlesCollection.items}
                    isEmbedView={isEmbedView}
                  />
                  <MatchPlayLeaderboard
                    {...props}
                    {...response}
                    leaderboardRef={leaderboardRef}
                    isEmbedView={isEmbedView}
                  />
                </>
              )}
            </ErrorBoundary>
          ) : <div />
        }}
      </Query>
    </NoSsr>
  )
}

MatchPlayLeaderboardWithData.propTypes = {
  fullLeaderboard: PropTypes.bool,
  isEmbedView: PropTypes.bool,
  findCoachTitle: PropTypes.string,
  findCoachSubtitle: PropTypes.string,
  findCoachCta: PropTypes.string,
  articles: PropTypes.object,
}
